import { render, staticRenderFns } from "./user-verify.view.vue?vue&type=template&id=c86f63a0&scoped=true&"
import script from "./user-verify.view.ts?vue&type=script&lang=ts&"
export * from "./user-verify.view.ts?vue&type=script&lang=ts&"
import style0 from "./user-verify.view.scss?vue&type=style&index=0&id=c86f63a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f63a0",
  null
  
)

export default component.exports